enum NotificationType {
    GENERAL = "GENERAL",
    ALERT = "ALERT",
    NEW_COMMENT = "NEW_COMMENT",
}

export default NotificationType;